import { addLocale, locale, updateLocaleOptions } from 'primereact/api';
import { en } from './locales/en';
import { ru } from './locales/ru';

updateLocaleOptions(en, 'en');
addLocale('ru', ru);
locale('ru');

export * from './methods';
